/**
 * Determine if an object is a promise.
 */
export function isPromise(input: Record<string, unknown>): boolean {
  return "then" in input;
}
